import * as Yup from 'yup';

interface IErrors {
  required?: string,
  maxLength: string,
}

function validationSchema(maxLength: number, errors: IErrors) {
  return Yup.object().shape({
    field: Yup.string()
      .max(maxLength, errors.maxLength.replace('{max}', `${maxLength}`))
  });
}

export const validationTextField = (val: any, maxLength: number, errors: IErrors) => {
  const value = { field: val };

  const schema = validationSchema(maxLength, errors);

  try {
    schema.validateSync(value, { abortEarly: false });
    return undefined;
  } catch (error: any) {
    return error.inner[0].errors[0];
  }
};
